export default __webpack_public_path__ + "static/media/deer_gray.a3ba06b5.svg";